// extracted by mini-css-extract-plugin
export var textInput = "_kr-0";